const BoltIcon = () => {
  return (
    <svg viewBox="0 0 30 30" width="45" height="45" xmlns="http://www.w3.org/2000/svg">
      <path d="M 11.694 10.056 C 12.636 10.774 16.716 14.191 17.221 14.635 C 18.136 14.266 27.712 10.288 28.347 10.288 C 27.926 11.082 18.046 19.754 17.633 20.006 C 16.86 19.744 12.36 15.929 11.817 15.448 C 11.339 15.641 0.562 20.05 0.516 20.029 C 4.082 16.982 8.019 13.196 11.694 10.056 Z" />
    </svg>
  )
}

export default BoltIcon
